var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 196.7 196.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#46c9f7;}.cls-2{fill:#01aef0;}.cls-3{fill:#0162b1;}.cls-4{fill:#0082ca;}.cls-5{fill:#0d80ce;}.cls-6{fill:#d9f7fc;}.cls-7{fill:#03476d;}.cls-8{fill:#016bb7;}.cls-9{fill:#aeedfc;}.cls-10{fill:#045b96;}.cls-11{fill:#084f7f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.3 0 66.8 66.8 0 98.3 98.3 98.3 98.3 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.3 0 129.9 66.8 196.7 98.3 98.3 98.3 98.3 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.3 196.7 66.8 129.9 0 98.3 98.3 98.3 98.3 196.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "98.3 196.7 129.9 129.9 196.7 98.3 98.3 98.3 98.3 196.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "66.8 98.3 66.8 98.3 98.3 129.9 98.3 98.3 66.8 98.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "98.3 66.8 66.8 98.3 98.3 98.3 98.3 66.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "129.9 98.3 98.3 98.3 98.3 129.9 129.9 98.3 129.9 98.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "129.9 98.3 98.3 66.8 98.3 98.3 129.9 98.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.9 98.3 98.3 66.8 129.9 66.8 129.9 98.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "98.3 66.8 66.8 98.3 66.8 66.8 98.3 66.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "98.3 129.9 129.9 98.3 129.9 129.9 98.3 129.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "66.8 98.3 98.3 129.9 66.8 129.9 66.8 98.3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond1);
export default __webpack_public_path__ + "static/media/diamond-1.c87e6bd7d3c61663a73be73fedfe8bbe.svg";
export { ForwardRef as ReactComponent };